// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Common from '@/components/Common'
import ProcessDialog from '@/components/ProcessDialog'
import Vant from 'vant';
import 'vant/lib/index.css';
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import {post, fetch, patch, put, filePost, bodyPost, fileFetch} from './utils/http'
import VideoPlayer from 'vue-video-player'
import md5 from 'js-md5';
import BaiduMap from 'vue-baidu-map'
import 'amfe-flexible'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

//定义全局变量
Vue.prototype.Common = Common;
Vue.prototype.$post = post;
Vue.prototype.$filePost = filePost;
Vue.prototype.$bodyPost = bodyPost;
Vue.prototype.$fetch = fetch;
Vue.prototype.$fileFetch = fileFetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;//赋值使用

Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(VueMomentJS, moment);
Vue.use(VideoPlayer)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'hlf8PlERrXi4XU2v4nXV4KhwfZw7HRsb'
})
Vue.component("ProcessDialog", ProcessDialog);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js